class RouteNames {
  static readonly AuthCallback: string = 'AuthCallback';
  static readonly Login: string = 'Login';
  static readonly NotFound: string = 'Error404';
  static readonly Unauthorized: string = 'Error403';

  static readonly Employee = class {
    static readonly Create: string = 'EmployeeCreate';
    static readonly Edit: string = 'EmployeeEdit';
    static readonly List: string = 'EmployeeList';
  };

  static readonly Foreman = class {
    static readonly Create: string = 'ForemanCreate';
    static readonly Edit: string = 'ForemanEdit';
    static readonly List: string = 'ForemanList';
  };

  static readonly Hardware = class {
    static readonly List: string = 'HardwareList';
  };

  static readonly Movement = class {
    static readonly Create: string = 'MovementCreate';
    static readonly Edit: string = 'MovementEdit';
    static readonly List: string = 'MovementList';
  };

  static readonly Project = class {
    static readonly List: string = 'ProjectList';
  };
}

export default RouteNames;
